import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-new',
  templateUrl: './new.component.html',
  styleUrls: ['./new.component.scss']
})
export class NewComponent implements OnInit {
  @Input() urlBack = "/login";
  @Input() title = "TÍTULO PADRÃO";
  @Input() subtitle = "Subtítulo padrão";

  constructor() { }

  ngOnInit() {
  }

}
